import { lazy, type ReactNode, Suspense } from "react";
import { TextChannelView } from "./app/text-channel";
import { ThreadComponent } from "./app/thread";
import { BroadcastControlPanel } from "./components/app/broadcast-control-panel";
import { CombinedVoiceBroadcastView } from "./components/app/combined-voice-broadcast-view";
import { ScheduleView } from "./components/app/schedule-view";

const LazyDocumentViewer = lazy(
	() => import("./components/app/document-viewer")
);

function DocumentViewerWrapper({ documentId }: { documentId: string }) {
	return (
		<Suspense
			fallback={
				<div className="flex h-full items-center justify-center">
					<p className="text-muted-foreground">Loading document viewer...</p>
				</div>
			}
		>
			<LazyDocumentViewer documentId={documentId} />
		</Suspense>
	);
}

type GridRoute = {
	component: (params: any) => ReactNode;
};

export const gridRoutes = {
	schedule: {
		component: ScheduleView,
	},
	textChannel: {
		component: TextChannelView,
	},
	voiceChannel: {
		component: CombinedVoiceBroadcastView,
	},
	thread: {
		component: ThreadComponent,
	},
	broadcastControls: {
		component: BroadcastControlPanel,
	},
	document: {
		component: DocumentViewerWrapper,
	},
} as const satisfies Record<string, GridRoute>;

type UnionType<T> = T[keyof T];

export type GridRoutes = UnionType<{
	[key in keyof typeof gridRoutes]: Parameters<
		(typeof gridRoutes)[key]["component"]
	>[0] extends undefined
		? {
				type: key;
				params?: never;
			}
		: {
				type: key;
				params: Parameters<(typeof gridRoutes)[key]["component"]>[0];
			};
}>;
